import { array } from 'fp-ts';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedProperty, lt } from '@mews/framework';
import { Stack, StackItem } from '@optimus-web/core';
import { SpacedComma, SubContentSection } from '@mews-commander/ui';
import { useSelectedRateGroupsContext } from '../../hooks';
import { useLocalRateGroupWithPolicyExceptionsGet, useRatesByIds } from '../queries';
import { CancellationPolicyName, SettlementRuleName } from '../../../../../../../components';
import { TimeUnitIntervals } from './TimeUnitIntervals';

export const PolicyExceptionsSection = () => {
    const selectedRateGroups = useSelectedRateGroupsContext();
    const { data: rateGroupsWithPolicyExceptions } = useLocalRateGroupWithPolicyExceptionsGet({
        rateGroupIds: selectedRateGroups.map(({ id }) => id),
        enterpriseIds: selectedRateGroups.map(({ enterpriseId }) => enterpriseId),
    });

    const { data: ratesByIds } = useRatesByIds({
        enterpriseIds: selectedRateGroups.map(({ enterpriseId }) => enterpriseId),
        rateIds: rateGroupsWithPolicyExceptions
            .flatMap(({ policyExceptions }) => policyExceptions)
            .flatMap(({ rateIds }) => rateIds || []),
    });

    return (
        <SubContentSection title={lt('GeneralPolicyExceptionPlural')}>
            {array.isNonEmpty(rateGroupsWithPolicyExceptions)
                ? rateGroupsWithPolicyExceptions.map(({ policyExceptions, names }) =>
                      policyExceptions.map(
                          ({ id, timeUnitIntervals, settlementRules, cancellationPolicies, rateIds }) => (
                              <StackItem key={id}>
                                  <TimeUnitIntervals timeUnitIntervals={timeUnitIntervals} />
                                  {rateIds
                                      ? rateIds.map((rateId) => ratesByIds[rateId].name).join(SpacedComma)
                                      : names && <LocalizedProperty property={names} />}
                                  <Stack vertical>
                                      {settlementRules.map((settlementRule) => (
                                          <SettlementRuleName
                                              {...settlementRule}
                                              format="nameAndParameters"
                                              key={settlementRule.id}
                                          />
                                      ))}
                                      {cancellationPolicies.map((cancellationPolicy) => (
                                          <CancellationPolicyName
                                              {...cancellationPolicy}
                                              format="nameAndParameters"
                                              key={cancellationPolicy.id}
                                          />
                                      ))}
                                  </Stack>
                              </StackItem>
                          )
                      )
                  )
                : UnicodeEntity.Dash}
        </SubContentSection>
    );
};
